// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1NRph","content":"RecentSearches_content__3ue0e"};